export default function globalAction(type, payload) {
    return {
        type,
        payload
    };
}
